export default __webpack_public_path__ + "static/media/Linkedin.91d4e814.png";